import { render, staticRenderFns } from "./FormDesigner.vue?vue&type=template&id=a680b4bc&scoped=true&"
import script from "./FormDesigner.vue?vue&type=script&lang=js&"
export * from "./FormDesigner.vue?vue&type=script&lang=js&"
import style0 from "./FormDesigner.vue?vue&type=style&index=0&id=a680b4bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680b4bc",
  null
  
)

export default component.exports